// extracted by mini-css-extract-plugin
export default {"navigation":"kiMVxg7uvmObzH9y5Nf7","subtitle":"lh6Gp5uMZoFjdsD0piCQ","active":"IHgUS1orY8DkWO_fbRhQ"};